export { default } from './AthenaPatientDetailsPopup';
